/**
 * waits until HTML is ready to be accessed
 * @returns 
 */
export const domReady = () =>
    (document.readyState === 'interactive' || document.readyState === 'complete')
        ? Promise.resolve()
        : new Promise(res => document.addEventListener('DOMContentLoaded', res, { once: true }));

/**
 * waits until page load is complete
 * @returns 
 */
export const afterLoad = () =>
    (document.readyState === 'complete')
        ? Promise.resolve()
        : new Promise(res => window.addEventListener('load', res, { once: true }));